module.exports = __webpack_public_path__ + "img/固安渔具.d2b7ed4c.jpg";